import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { extractPriceValue } from '../utils/priceUtils';

const ProductCard = ({ product, index = 0 }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
  };

  const formatPrice = (price) => {
    // 如果价格已经是格式化的字符串（如 "S$22.90"），直接返回
    if (typeof price === 'string') {
      return price;
    }
    // 如果价格是数字，格式化为 "S$" 格式
    return `S$${price.toFixed(2)}`;
  };

  return (
    <div className="group bg-gray-800 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
      <Link to={`/product/${product.id}`}>
        <div className="p-3 sm:p-4">
          {/* Product Image */}
          <div className="relative mb-2 sm:mb-3 md:mb-4 overflow-hidden rounded-lg bg-gray-700">
            <img
              src={product.image}
              alt={product.name}
              className="w-full aspect-square object-cover object-center group-hover:scale-105 transition-transform duration-300"
              onError={(e) => {
                e.target.src = '/images/products/placeholder.jpg';
              }}
            />
            
            {/* Discount Badge */}
            {product.originalPrice && extractPriceValue(product.originalPrice) > extractPriceValue(product.price) && (
              <div className="absolute top-1 left-1 sm:top-2 sm:left-2 bg-red-600 text-white px-1.5 py-0.5 sm:px-2 sm:py-1 rounded text-xs sm:text-sm font-bold">
                -{Math.round(((extractPriceValue(product.originalPrice) - extractPriceValue(product.price)) / extractPriceValue(product.originalPrice)) * 100)}%
              </div>
            )}
            
            {/* Stock Status */}
            <div className="absolute top-1 right-1 sm:top-2 sm:right-2">
              <span className={`px-1.5 py-0.5 sm:px-2 sm:py-1 rounded text-xs font-bold ${
                product.inStock 
                  ? 'bg-green-600 text-white' 
                  : 'bg-red-600 text-white'
              }`}>
                {product.inStock ? 'In Stock' : 'Out of Stock'}
              </span>
            </div>
          </div>

          {/* Product Info */}
          <div className="space-y-1.5 sm:space-y-2 md:space-y-3">
            {/* Category */}
            <div className="flex items-center justify-between">
              <span className="text-xs sm:text-sm text-gray-400 font-medium uppercase tracking-wider">
                {product.category}
              </span>
              {/* Rating */}
              <div className="flex items-center space-x-1">
                <span className="text-yellow-400 text-sm">★</span>
                <span className="text-sm font-medium text-white">{product.rating}</span>
                <span className="text-xs text-gray-400">({product.reviews})</span>
              </div>
            </div>

            {/* Product Name */}
            <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-white group-hover:text-green-400 transition-colors duration-200 leading-tight line-clamp-2">
              {product.name}
            </h3>

            {/* Description */}
            <p className="text-gray-300 text-xs leading-relaxed line-clamp-2 hidden md:block">
              {product.description}
            </p>

            {/* Price Section */}
            <div className="flex items-center pt-1">
              <div className="flex items-center space-x-1">
                <span className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-white">
                  {formatPrice(product.price)}
                </span>
                {product.originalPrice && extractPriceValue(product.originalPrice) > extractPriceValue(product.price) && (
                  <span className="text-xs sm:text-sm text-gray-400 line-through">
                    {formatPrice(product.originalPrice)}
                  </span>
                )}
              </div>
            </div>
            
            {/* Add to Cart Button */}
            <div className="pt-1">
              <button
                className={`w-full py-1.5 sm:py-2 md:py-2.5 rounded-md font-medium text-sm transition-all duration-200 ${
                  product.inStock
                    ? 'bg-green-600 hover:bg-green-700 text-white'
                    : 'bg-gray-600 text-gray-400 cursor-not-allowed'
                }`}
                onClick={handleAddToCart}
                disabled={!product.inStock}
              >
                {product.inStock ? 'Add to Cart' : 'Out of Stock'}
              </button>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
